import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { OnClickConfig } from 'sections/onsite-campaigns/types';

export const useSetOnClick = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (onClick: OnClickConfig) =>
      dispatch({
        type: 'SET_ON_CLICK_CONFIG',
        payload: {
          onClick,
        },
      }),
    [dispatch],
  );
};
